import React, { useEffect, Fragment, useState, useCallback } from 'react';
import {
    Row,
    Col,
    Card,
    Button,
    CardBody,
    ListGroup,
    ListGroupItem,
    Container,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import UserRelationGroupStatuses from '../../../../../enums/UserRelationGroupStatuses';
import UserRoles from '../../../../../enums/UserRoles';
import FilterStatuses from '../../../../../enums/FilterStatuses';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';

export default function ReceiversList({ id, activeTab, setActiveTab, filter, newUser, changeSeniorCountCallBack }) {
    const [receiversData, setReceiversData] = useState();
    const { toggleLoading, setGlobalUpdate, currentGroup } = useAuth();
    const phonePrefix = (currentGroup.hvpn && currentGroup.hvpn === '1') ? '*67' : '';

    const [lastId, setLastId] = useState(null);

    const loadReceivers = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listGiverToReceiverForGiver/${id.id}`)
            .then((response) => {
                setReceiversData(response.data.items);
                setLastId(response.data.lastId);
                if (changeSeniorCountCallBack) {
                    changeSeniorCountCallBack(`${response.data.items.length}`);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [id, toggleLoading, setLastId, changeSeniorCountCallBack]);

    const loadMore = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listGiverToReceiverForGiver/${id.id}`, {lastId})
            .then((response) => {
                const count = receiversData.length + response.data.items.length;
                setReceiversData([...receiversData, ...response.data.items]);
                setLastId(response.data.lastId);
                if (changeSeniorCountCallBack) {
                    changeSeniorCountCallBack(`${count}`);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, receiversData, id, lastId, setLastId, changeSeniorCountCallBack]);

    useEffect(() => {
        if (activeTab === UserRoles.RECEIVER.toString()) {
            loadReceivers();
        }
        if (newUser === UserRoles.RECEIVER.toString()) {
            loadReceivers();
        }
    }, [activeTab, newUser, loadReceivers]);

    const check = (member) => {
        if (filter.id === '') {
            return true;
        }

        if (
            filter.id === FilterStatuses[0].id &&
            (member.status.code ===
                UserRelationGroupStatuses.ACCEPTED_BY_PARENT ||
                member.status.code ===
                    UserRelationGroupStatuses.ACCEPTED_BY_CHILD)
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[1].id &&
            (member.status.code ===
                UserRelationGroupStatuses.REQUESTED_BY_CHILD ||
                member.status.code ===
                    UserRelationGroupStatuses.INVITED_BY_PARENT)
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[2].id &&
            member.status.code === UserRelationGroupStatuses.SUSPENDED
        ) {
            return true;
        }

        if (
            filter.id === FilterStatuses[3].id &&
            (member.status.code ===
                UserRelationGroupStatuses.REJECTED_BY_CHILD ||
                member.status.code ===
                    UserRelationGroupStatuses.REJECTED_BY_PARENT)
        ) {
            return true;
        }
    };

    const showReceiverEmail = useCallback((email) => {
        if (email.includes('@noemail.com')) {
            return `No email`;
        } else {
            return email;
        }
    }, []);

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup flush className="users-list">
                                {receiversData &&
                                    receiversData.map(
                                        (member) =>
                                            check(member) && (
                                                <ListGroupItem key={member.id}>
                                                    <div className="widget-content p-0">
                                                        <div className="widget-content-wrapper">
                                                            <div className="widget-content-left mr-3">
                                                                <div className="placeholder-avatar">
                                                                    {member.name
                                                                        ? member.name.charAt(
                                                                              0
                                                                          )
                                                                        : member.email.charAt(
                                                                              0
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-left">
                                                                <div className="widget-heading">
                                                                    {member.name &&
                                                                        member.name}
                                                                </div>
                                                                <div className="widget-subheading">
                                                                    {
                                                                        showReceiverEmail(member.email)
                                                                    }
                                                                </div>
                                                                <div className="widget-subheading">
                                                                    {member.phone && (
                                                                        <a href={`tel:${phonePrefix}${member.phone}`} target="_blank" rel="noopener noreferrer">{member.phone}</a>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-right">
                                                                <Fragment>
                                                                    <UncontrolledButtonDropdown direction="left">
                                                                        <DropdownToggle color="primary">
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faBars
                                                                                }
                                                                                size="1x"
                                                                            />
                                                                        </DropdownToggle>
                                                                        <DropdownMenu className="no-arrow">
                                                                            <DropdownItem
                                                                                header
                                                                            >
                                                                                Actions
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                                divider
                                                                            />

                                                                            <DropdownItem
                                                                                onClick={() => {
                                                                                    setActiveTab('7');
                                                                                    setGlobalUpdate({setNeedOfReceiver: member.id})
                                                                                }}
                                                                            >
                                                                                View
                                                                                Needs
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </UncontrolledButtonDropdown>
                                                                </Fragment>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ListGroupItem>
                                            )
                                    )}
                            </ListGroup>
                            {receiversData && receiversData !== undefined && receiversData.length === 0 && (
                                <CardBody>
                                    <p>You don't have any assigned Senior yet. You may want to talk to your Group Coordinator and see if there is a Senior in your community that needs support</p>
                                </CardBody>
                            )}
                        </Card>

                        {lastId !== null && (
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={loadMore}
                                >
                                    Load more
                                </Button>
                            </div>
                        )}

                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
